// PREF-UC-1: языки интерфейса. Новый язык — новая строка здесь и словари в apps/web.
export enum Locale {
  Ru = 'ru',
  En = 'en',
}

export const DEFAULT_LOCALE = Locale.Ru;

export const LOCALES: readonly { id: Locale; nativeName: string }[] = [
  { id: Locale.Ru, nativeName: 'Русский' },
  { id: Locale.En, nativeName: 'English' },
];

export function isLocale(value: unknown): value is Locale {
  return LOCALES.some((locale) => locale.id === value);
}
